import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { TypedRiskMatrixPanel } from '../../report/TypedRiskMatrixPanel';
import { SectionShell } from '../SectionShell';

export const SupplyChainRiskMatrixSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const risks = report.developmentRisks ?? [];
  const hasData = risks.length > 0;

  return (
    <SectionShell label={label} hasData={hasData} report={report} sectionId="supplyChainRiskMatrix" required>
      <TypedRiskMatrixPanel
        risks={risks}
        references={report.references}
        testIdPrefix="supply-chain-risk-matrix"
      />
    </SectionShell>
  );
};
